import React, { useEffect, useState } from "react";
import {Bookmark, Calendar, Cast, Command, Edit, Filter, Loader, Search, Star} from "react-feather";
import {ComponenteFeature} from "../Componentes/indexComponentes";
import {Container} from "../Home/styleHome";
import {Animated} from "react-animated-css";
import {
    Container1, Container1Texto,
    Container2,

    ContainerHeader,
    Triangulo
} from "../Componentes/styleComponentes";
import img_licitacoes from "../imagens/licitacao@2x.png";
import painel from '../imagens/painel_licitacao.png'

import "animate.css/animate.css";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ImagemApresentacao} from "../Apresentacao/styleApresentacao";

const texto =
    "Tenha acesso a todas as informações do procedimento licitatório, centralizadas e organizadas e atualizadas em apenas um lugar."
export const Licitacao = ({licitacao}) => {
    const [animacao1, setAnimacao1] = useState(true);

    const slideImg = () => {
        setInterval(() => { setAnimacao1(!animacao1)}, 10000);
    };

    useEffect(() => {
        slideImg()
    },[animacao1]);

    return (
        <Container id={"licitacoes"}>
            <ContainerHeader>
                <Container1 background={"#28634b"}>
                    <Container1Texto paddingLeft={"100px"}>
                        <div style={{display: "flex"}}>
                            <div style={{ fontSize: "50px", marginRight: "20px" }}>
                                <FontAwesomeIcon icon={"gavel"} color="#00000" />
                            </div>
                            <header>
                                <span style={{color: "#e2e2e2"}}>MÓDULO</span>
                                <h2>LICITAÇÕES</h2>
                            </header>
                        </div>
                        <div>
                            <p>{texto}</p>
                        </div>
                    </Container1Texto>
                    {animacao1 && licitacao?

                        <ImagemApresentacao scroll={animacao1 && licitacao}>
                            <img
                                src={img_licitacoes}
                                height={"auto"}
                                width={"99%"}
                                alt={"editais"}
                            />

                        </ImagemApresentacao>

                        :
                        <Animated animateOnMount = {!animacao1} animationIn="fadeInRight" animationOut="fadeOut" animationInDuration={1000} animationOutDuration={1000}   isVisible={!animacao1}>


                        <img
                        src={painel}
                        height={"auto"}
                        width={"99%"}
                        alt={"editais"}
                        />

                        </Animated>




                    }


                </Container1>
                <Triangulo/>
                <Container2>
                    <ComponenteFeature
                        status={licitacao}
                        titulo={"LICITAÇÕES DO DIA"}
                        subTitulo={"PAINEL DE CRONOGRAMA DIÁRIO"}
                        icone={<Cast/>}
                        texto={
                            "Visualize todas as licitações que serão disputadas no dia em ordem cronológica, atualizadas em tempo real."}
                    />

                    <ComponenteFeature
                        status={licitacao}
                        titulo={"SINCRONIZAÇÃO AUTOMÁTICA"}
                        subTitulo={"CADASTRO DE NOVAS LICITAÇÕES"}
                        icone={<Loader/>}
                        texto={
                            "Nós importamos e sincronizamos automaticamente todos os pregões eletrônicos que estão em andamento."}
                    />

                    <ComponenteFeature
                        status={licitacao}
                        titulo={"MODO AGENDA"}
                        subTitulo={"VISUALIZAÇÃO DINÂMICA DAS LICITAÇÕES"}
                        icone={<Calendar/>}
                        texto={
                            "Visualize suas licitações na agenda e acompanhe de forma dinâmica o seu progresso."}
                    />
                    <ComponenteFeature
                        status={licitacao}
                        titulo={"MODO FUNIL"}
                        subTitulo={"SEPARE SUAS LICITAÇÕES POR ETAPA"}
                        icone={<Filter/>}
                        texto={
                            "Tenha uma visão macro do andamento de todas as licitações participadas."}
                    />
                </Container2>
            </ContainerHeader>
        </Container>
    );
};
